import { ApiGldGldsListRequest, GLD } from "@nens/brostar/openapi-client";
import { qualityRegimeOptionsType } from "@nens/brostar/uploadapi-client";

import { SearchOption } from "@/components/searchbox";

export const gldInformation: SearchOption<keyof GLD, keyof ApiGldGldsListRequest>[] = [
  { key: "broId", searchKey: "broIdIcontains", label: "BRO-ID" },
  { key: "gmwBroId", label: "Put-ID" },
  { key: "tubeNumber", label: "Buisnummer" },
  { key: "researchFirstDate", label: "Eerste datum" },
  { key: "researchLastDate", label: "Laatste datum" },
  {
    key: "qualityRegime",
    label: "Kwaliteitsregime",
    enum: qualityRegimeOptionsType.map((option) => ({ key: option, label: option })),
  },
];
